<template>
    <div class="cover"></div>
</template>

<script>
    export default {
        name: 'Cover',
        props: {
            configuration: Object
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    .cover
    {

    }
</style>